module.exports = __webpack_public_path__ + "media/images/f_logo_RGB-Blue_72@3x-33291dd9b6d48f1bcf91715e370e6aa9.png";